import {
  LOG_HISTORY_SET_PAGINATION,
  LOG_HISTORY_SET_FILTERS,
  LOG_HISTORY_RESET_FILTERS,
  LOG_HISTORY_SET_SORTING,
  EVENT_LOG_HISTORY_FILTER_SUBMIT,
} from "./mutation";

export default {
  namespaced: true,
  state: {
    collection: [],
    item: {
      logHistory: {},
      tainted: false,
      id: null,
    },
    paginator: {
      page: 1,
      pageSize: parseInt(process.env.VUE_APP_LIST_DEFAULT_SIZE),
    },
    sorting: {},
  },
  mutations: {
    [LOG_HISTORY_SET_PAGINATION](state, data) {
      state.paginator = { ...state.paginator, ...data };
    },
    [LOG_HISTORY_SET_FILTERS](state, data) {
      state.filters = {
        ...state.filters,
        ...data,
      };
    },
    [LOG_HISTORY_RESET_FILTERS](state) {
      state.filters = { page: 1 };
      state.paginator = {
        page: 1,
        pageSize: parseInt(process.env.VUE_APP_LIST_DEFAULT_SIZE),
      };
    },
    [LOG_HISTORY_SET_SORTING](state, data) {
      state.sorting = { ...state.sorting, ...data };
    },
    [EVENT_LOG_HISTORY_FILTER_SUBMIT]() {},
  },
  getters: {
    getAll: (state) => {
      return {
        ...state.paginator,
        ...state.filters,
        ...state.sorting,
      };
    },
  },
  actions: {
    async setPagination({ commit }, { ...params }) {
      commit(LOG_HISTORY_SET_PAGINATION, params);
    },
    async setFilters({ commit }, { ...params }) {
      commit(LOG_HISTORY_SET_FILTERS, params);
    },
    async resetFilters({ commit }) {
      commit(LOG_HISTORY_RESET_FILTERS);
    },
    async setSorting({ commit }, { ...params }) {
      commit(LOG_HISTORY_SET_SORTING, params);
    },
    async submitFilterForm({ commit }, { ...params }) {
      commit(EVENT_LOG_HISTORY_FILTER_SUBMIT, params);
    },
  },
};
